import { IPagination } from '../model';
import { DEFAULT_PAGE_SIZE } from './constant';

export const getDefaultPaginationInfo = (pagination?: IPagination) => {
  return Object.assign(
    {
      current: 1,
      pageSize: 100,
      total: 0,
    },
    pagination
  );
};

export const getDefaultPageSizeOptions = () => {
  return ['10', '20', '50', '100'];
};

// 从原始数据中获取当前分页位置
export const getCurrentPaginationStartNumber = (
  dataLen: number,
  pagination?: IPagination
) => {
  if (!pagination?.current) {
    return null;
  }

  // 这段代码引起性能问题,先注释
  /* if (pagination.total !== dataLen || !pagination.total) {
    return null;
  }*/

  const { current, pageSize = DEFAULT_PAGE_SIZE } = pagination;
  const start = (current - 1) * pageSize;
  return {
    start: start > 0 ? start : 0,
    end: current * pageSize,
  };
};

export function getCurrentPageData<T>(
  data: ReadonlyArray<T>,
  pagination?: IPagination
) {
  const pageInfo = getCurrentPaginationStartNumber(data.length, pagination);
  if (pageInfo) {
    return data.slice(pageInfo.start, pageInfo.end);
  }
  return data;
}
